import styled from "styled-components";

export const Container = styled.div`
  background: ${({ theme }) => theme.palette.background.paper};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  padding: 25px;
  max-width: 750px;
  align-items: center;
  margin-top: 15px;
`;

// export const FieldsContainer = styled.div`
//   display: grid;
//   grid-template-columns: 1fr 1fr;
//   row-gap: 15px;
// `;

// export const ActionsContainer = styled.div`
//   display: flex;
//   width: 100%;
//   justify-content: flex-end;
//   margin-top: 15px;
// `;

// export const FormContainer = styled.div`
//   margin-top: 15px;
// `;

// export const FormRow = styled.div`
//   display: flex;
// `;
